var Curriculog = Curriculog || {};

Curriculog.SimpleWarningDialog = (function ($, _, Backbone, SimpleWarningDialog) {

	SimpleWarningDialog = Curriculog.Dialog.extend({
		title: 'Warning',
		dialogClass: 'curriculog-dialog warning',
		itemType: 'itemType',
		itemName:'itemName',

		buttons: function () {
			return {
				'OK': 'close',
			};
		},
	});
	return SimpleWarningDialog;

})($, _, Backbone, Curriculog.SimpleWarningDialog || {});
